import React from 'react'
import { Link } from 'react-router-dom'
import './Home.css'
import ChatBot from '../../components/ChatBot/ChatBot'

export default function Home() {
    return (
        <div className='home-container'>
            <div className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">Transform Your Practice</h1>
                    <h2 className="hero-subtitle">With AI-Powered Yoga Training</h2>
                    <p className="hero-description">
                        Perfect your poses with real-time AI feedback. 
                        Practice anywhere, anytime with your personal yoga assistant.
                    </p>
                    <div className="hero-buttons">
                        <Link to='/start'>
                            <button className="primary-button">
                                Start Practice
                            </button>
                        </Link>
                        {/* <Link to='/tutorials'>
                            <button className="secondary-button">
                                View Tutorials
                            </button>
                        </Link> */}
                    </div>
                </div>
                <div className="hero-image">
                    <div className="image-container">
                        <div className="blob-shape"></div>
                        <img 
                            src="/yoga-bg.png"
                            alt="Yoga Pose" 
                            className="floating-image"
                        />
                    </div>
                </div>
            </div>
            <div className="features-section">
                <div className="feature-card">
                    <div className="feature-icon">🎯</div>
                    <h3>Real-time Pose Detection</h3>
                    <p>Get instant feedback on your yoga poses</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">🧘</div>
                    <h3>Multiple Poses</h3>
                    <p>Learn and perfect various yoga poses</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">📱</div>
                    <h3>Practice Anywhere</h3>
                    <p>All you need is your device and a camera</p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">💬</div>
                    <h3>AI Yoga Assistant</h3>
                    <p>Get personalized yoga and wellness advice</p>
                </div>
            </div>
            
            {/* Integrate the ChatBot component */}
            <ChatBot />
        </div>
    )
}
